import { coreActions } from '@sonar-software/sonar-core';
import { useAction } from '../useAction';
import { useCallback } from 'react';
export function useDataDictionaryReset() {
    const resetDataDictionary = useAction(coreActions.resetGetCoreDataDictionary);
    const resetDataDictionarySearch = useAction(coreActions.resetGetCoreDataDictionarySearch);
    const resetAll = useCallback(() => {
        resetDataDictionary();
        resetDataDictionarySearch();
    }, [resetDataDictionary, resetDataDictionarySearch]);
    return {
        resetAll,
        resetData: resetDataDictionary,
        resetSearch: resetDataDictionarySearch
    };
}
